import ConfiguracaoIncubacaoMnemonicos from "./ConfiguracaoIncubacaoMnemonicos";

export default function MapaTraceAbas({
  aba,
  setAba,
  podeConfigurarIncubacao,
  children,
}) {
  return (
    <>
      <div id="container-aba-ctrl" className="mapa-trace-abas">
        <button
          type="button"
          id={
            aba === "amostras"
              ? "button-aba-ctrl-samples-selected"
              : "button-aba-mapatrace-amostras"
          }
          className="button-aba-ctrl"
          onClick={() => setAba("amostras")}
        >
          Controle de Amostras
        </button>
        {podeConfigurarIncubacao && (
          <button
            type="button"
            id={
              aba === "configuracao"
                ? "button-aba-ctrl-samples-selected"
                : "button-aba-mapatrace-config"
            }
            className="button-aba-ctrl"
            onClick={() => setAba("configuracao")}
          >
            Configurações
          </button>
        )}
      </div>

      {aba === "amostras" ? children : <ConfiguracaoIncubacaoMnemonicos />}
    </>
  );
}
